// eslint-disable-next-line jira/restricted/moment
import moment from 'moment';

export const formatDate = (date?: number): string | null =>
	date !== undefined ? moment.utc(date).format('YYYY-MM-DD') : null;
